<template>
  <a class="text-gray-600 flex items-center" :href="frontDocUrl" target="_blank" :title="$tl('help')">
    <i class="n-helper fas fa-question-circle" />
  </a>
</template>

<script setup>
import {useDoc} from '@front/hooks';

const { frontDocUrl } = useDoc()
</script>

<script>
export default {
  name: 'NHelper',
};
</script>

<style lang="less">
.n-helper {
  font-size: 150%;
  cursor: pointer;
}
</style>
